import api from "./api";

export async function getEquipamentsStatus(usinaId) {
    const res = await api.get(`equipaments/status?usinaId=${usinaId}`);
    return res.data;
}
